<!--<app-dialog-base class="modalcreateuser" [Title]='"Sensor settings"|translate' [dialogId]="dialogId" (onClose)="close()"
                 (onSubmit)="submit()">

</app-dialog-base>-->

<div class="modalbg" id="{{dialogId}}" style="display:grid">
  <div class="modal" [style.left.px]="offsetX" [style.top.px]="offsetY" [style.position]="position" style="height:550px">
    <div class="modalhead" (mousedown)="onMouseDown($event)">
      {{"Sensor settings"|translate}}
      <span (click)="closeN($event)" *ngIf="!isHeaderHidden">
        <img src="/assets/icons/close_white.svg" />
      </span>
    </div>
    <div class="modalbody">
      <div class="btn_tabs">
        <button (click)="openTab('main')" [class.active]="openedTabName == 'main'">{{"Main"|translate}}</button>
        <button (click)="openTab('events')" [class.active]="openedTabName == 'events'">{{"Events"|translate}}</button>
        <button (click)="openTab('calibration')" [class.active]="openedTabName == 'calibration'">
          {{"Calibration"|translate}}
        </button>
      </div>
      <div class="horseparator"></div>
      <div id="main" *ngIf="isSelected('main')" class="tablewrap">
        <div class="table">
          <div class="inputgroup">
            <label>{{'Name'|translate}}</label>
            <input type="text" [(ngModel)]="model.Name" />
          </div>
          <div class="inputgroup" style="z-index:101;">
            <label>
              {{'Color'|translate}}
            </label>
            <app-color-selector (onColorSelected)="model.Color = $event" [color]="model.Color"></app-color-selector>
          </div>
          <div class="inputgroup" style="z-index: 100;">
            <label>{{'Icon'|translate}} </label>
            <app-icon-selector [icons]="Icons" [selectedIcon]="model.IconId" (onIconSelected)="model.IconId = $event ? $event.Id : undefined;"></app-icon-selector>
          </div>
          <div class="inputgroup">
            <label>{{'Type'|translate}} </label>
            <!-- onDataTypeChange dont exist -->
            <select title="{{'Type'|translate}}" [(ngModel)]="model.DataType">
              <option value="0" [selected]="model.DataType == 0">{{'Numeric'|translate}}</option>
              <option value="1" [selected]="model.DataType == 1">{{'Discrete'|translate}}</option>
            </select>
          </div>
          <div class="inputgroup">
            <label (click)="openInputBinding()">{{'Input'|translate}} </label>
            <app-trend-input [(Input)]="model.Source" [Inputs]="Inputs"></app-trend-input>
          </div>
          <div class="inputgroup">
            <label>{{'Сonnected equipment'|translate}} </label>
            <select title="{{'Connected equipment'|translate}}" [(ngModel)]="trendtype">
              <option value=" " [selected]="trendtype == ''">&nbsp;</option>
              <option value="ALARM" [selected]="trendtype == 'ALARM'">{{'Alarm button'|translate}}</option>
              <option value="FUEL" [selected]="trendtype == 'FUEL'">{{'Fuel level'|translate}}</option>
              <option value="FL4MT" [selected]="trendtype == 'FL4MT'">{{'Equipment fuel level'|translate}}</option>

              <option value="FUEL COUNTER" [selected]="trendtype == 'FUEL COUNTER'">{{'Fuel cumulative counter'|translate}}</option>
              <option value="FUEL COUNTERSUMM" [selected]="trendtype == 'FUEL COUNTERSUMM'">{{'Fuel instant counter'|translate}}</option>

              <option value="COUNTER" [selected]="trendtype == 'COUNTER'">{{'Cumulative counter'|translate}}</option>
              <option value="COUNTERSUMM" [selected]="trendtype == 'COUNTERSUMM'">{{'Instant counter'|translate}}</option>

              <option value="MOTO" [selected]="trendtype == 'MOTO'">{{'Equipment status'|translate}}</option>
              <option value="ENGINE" [selected]="trendtype == 'ENGINE'">{{'Ignition'|translate}}</option>
              <option value="DRIVER" [selected]="trendtype == 'DRIVER'">{{'Driver'|translate}}</option>
              <option value="SEATBELT" [selected]="trendtype == 'SEATBELT'">{{'Seat belt'|translate}}</option>
              <option value="LIGHTS" [selected]="trendtype == 'LIGHTS'">{{'Lights'|translate}}</option>
              <option value="ODOMETR" [selected]="trendtype == 'ODOMETR'">{{'Odometer'|translate}}</option>
              <option value="TRACKVALID" [selected]="trendtype == 'TRACKVALID'">{{'Track validation'|translate}}</option>
            </select>
          </div>
          <div class="inputgroup" *ngIf="Zones.length && false">
            <label>{{'Zone'|translate}} </label>
            <!-- todo model.ZoneId does not exist -->
            <!-- <select title="{{'Zone'|translate}}" [(ngModel)]="model.ZoneId" (change)="onZoneChange($event)">
              <option *ngFor="let zone of Zones" value="{{zone.Id}}" [selected]="model.ZoneId == zone.Id">
                {{zone.Name|translate}}
              </option>
            </select> -->
          </div>
          <div class="inputgroup" *ngIf="model.DataType!=1">
            <label>{{'Scale'|translate}}</label>
            <div class="grid11">
              <div class="inputgroup grid18">
                <label>{{'From'|translate}}</label>
                <input type="number" value="0" [(ngModel)]="model.MinScale" />
              </div>
              <div class="inputgroup grid18">
                <label>{{'To'|translate}}</label>
                <input type="number" value="0" [(ngModel)]="model.MaxScale" />
              </div>
            </div>
          </div>
          <div class="inputgroup" *ngIf="model.DataType!=1">
            <label>{{'Scale unit'|translate}}</label>
            <input type="text" [(ngModel)]="model.Units" />
          </div>
          <div class="inputgroup">
            <label>{{'Smoothing'|translate}}</label>
             <p-slider [(ngModel)]="model.SmoothCount" [ngModelOptions]="{ standalone: true }" [step]="1" [min]="options.floor" [max]="options.ceil" class="w-56" />
          </div>
          <div class="inputgroup">
            <label>{{'Hidden'|translate}}</label>
            <input type="checkbox" [(ngModel)]="IsHidden" />
          </div>
        </div>
      </div>
      <div id="calibration" *ngIf="isSelected('calibration')" class="tablewrap">
        <div class="inputgroup">
          <label>{{'Raw scale'|translate}}</label>
          <div class="grid11">
            <div class="inputgroup grid18">
              <label>{{'From'|translate}}</label>
              <input type="number" [(ngModel)]="model.MinRawValue" />
            </div>
            <div class="inputgroup grid18">
              <label>{{'To'|translate}}</label>
              <input type="number" [(ngModel)]="model.MaxRawValue" />
            </div>
          </div>
        </div>

        <div class="inputgroup">
          <label>{{'Formula'|translate}}</label>
          <input type="text" [(ngModel)]="model.ValueCalcFormula" />
        </div>

        <div class="table">
          <table>
            <tr>
              <th>{{'Sensor raw value'|translate}}</th>
              <th>{{'Sensor value'|translate}}</th>
              <th>{{'Description'|translate}}</th>
              <th> <button class="btn_img btn_graygray btn_plusorange" (click)="addValue()"></button></th>
            </tr>
            <tr *ngFor="let val of model.CalibrationTable | orderBySensorValue :updated">
              <td> <input type="number" step="any" placeholder="0.00" [(ngModel)]="val.RawValue" /></td>
              <td><input type="number" step="any" placeholder="0.00" [(ngModel)]="val.Value" /></td>
              <td><input type="text" [(ngModel)]="val.Title" /></td>
              <td>
                <button class="btn_img btn_remove" (click)="removeValue(val)"></button>
              </td>
            </tr>
          </table>

        </div>
      </div>
      <div id="events" *ngIf="isSelected('events')" class="tablewrap">
        <div class="inputgroup">
          <label>{{'Permitted interval'|translate}}</label>
          <div class="grid11">
            <div class="inputgroup grid18">
              <label>{{'From'|translate}}</label>
              <input type="number" [(ngModel)]="model.LowAlarm" />
            </div>
            <div class="inputgroup grid18">
              <label>{{'To'|translate}}</label>
              <input type="number" [(ngModel)]="model.HighAlarm" />
            </div>
          </div>
        </div>
        <!-- <div class="inputgroup">
          <label>{{'Generate events'|translate}}</label>
          <input type="checkbox" [(ngModel)]="NotifyTreshold" />
        </div>
        <div class="inputgroup" *ngIf="NotifyTreshold">
          <label>{{'Hide for dispatcher'|translate}}</label>
          <input type="checkbox" [(ngModel)]="NoDispatch" />
        </div> -->
        <div class="inputgroup" *ngIf="model.DataType==1">
          <label>{{'Text for ON state'|translate}}</label>
          <input type="text" [(ngModel)]="model.OnText" />
        </div>
        <div class="inputgroup" *ngIf="model.DataType==1">
          <label>{{'Text for OFF state'|translate}}</label>
          <input type="text" [(ngModel)]="model.OffText" />
        </div>
      </div>
    </div>
    <div class="modalfooter">
      <div [style.display]="isSelected('calibration') ? 'block':'none'">
        <button class="btn_blue" (click)="export()">{{'Export'|translate}}</button>
        <button class="btn_blue" onclick="$('#myInput').click();">{{'Import'|translate}}</button>
        <input type="file" id="myInput" class="btn_blue" style="visibility:hidden;display:none"
               (change)="Incomingfile($event)"
               onclick="this.value=null"
               placeholder="{{'Import'|translate}}"
               accept=".xlsx,.xls,.txt,.csv">

      </div>
      <div class="footerbtns">
        <button class="btn_blue" (click)="submit()">{{'Apply'|translate }}</button>
        <button (click)="close()" class="btn_lgray">{{'Cancel'|translate }}</button>
      </div>
    </div>
  </div>
</div>

<template #trendBindingDialog></template>
